import { FC, useMemo } from 'react';
import { useAppSelector } from '@redux/store';
import RotatingSpinner from '@components/Blackbird/RotatingSpinner/RotatingSpinner';
import { Cancel, CheckCircle } from '@mui/icons-material';
import WarningIcon from '@mui/icons-material/Warning';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

import { getStatusIconString } from './helpers';
import { TIngestionStatusLabelProps } from './IngestionStatusLabel';

const IngestionStatusIcon: FC<
  Pick<
    TIngestionStatusLabelProps,
    'small' | 'status' | 'latestIngestionLog' | 'mode' | 'activeIngestionTables' | 'activeIngestion'
  >
> = ({ small, status, latestIngestionLog, mode, activeIngestionTables, activeIngestion }) => {
  const view = useAppSelector((state) => state.ingestionDataSourceList.view);

  const iconString = useMemo(
    () =>
      getStatusIconString({
        status,
        mode,
        view,
        latestIngestionLog,
        activeIngestionTables,
        activeIngestion,
      }),
    [activeIngestionTables, latestIngestionLog, mode, status, view, activeIngestion]
  );

  const dimension = useMemo(() => (small ? 16 : 18), [small]);

  switch (iconString) {
    case 'running-icon':
      return (
        <RotatingSpinner
          className="tw:text-primary-600"
          style={{ height: dimension, width: dimension }}
        />
      );
    case 'stopped-icon':
      return <Cancel className="tw:text-primary-600" style={{ fontSize: dimension }} />;
    case 'error-icon':
      return (
        <NewReleasesIcon className="tw:text-status-alert-text" style={{ fontSize: dimension }} />
      );
    case 'warning-icon':
      return (
        <WarningIcon className="tw:text-status-warning-text" style={{ fontSize: dimension }} />
      );
    case 'success-icon':
      return <CheckCircle className="tw:text-status-ok-text" style={{ fontSize: dimension }} />;
    default:
      return null;
  }
};

export default IngestionStatusIcon;
